import React from "react";
import LabReport from "../AdminPortal/LabReport";

const DMLabReport = () => {
  return <LabReport />;
};

export default DMLabReport;
